export const textToHTML = text => {
  if (!text) return '';
  let out = text.replaceAll(/(.*)\n/gi, '<div>$1</div>');
  out = out.replaceAll(/{{(.*?)}}/gi, '<span contentEditable="false" style="pointer-events:none">{{$1}}</span>');

  return out;
};
